/* ============================================
   EYEZY ULTIMATE THEME — CORE JAVASCRIPT
   ============================================ */

(function () {
  'use strict';

  /* --- UTILITIES --- */

  function formatMoney(cents) {
    var format = window.Shopify.money_format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json();
    });
  }

  /* --- HEADER --- */

  var Header = {
    init: function () {
      this.header = document.querySelector('[data-header]');
      if (!this.header) return;

      this.menuToggle = document.querySelector('[data-menu-toggle]');
      this.mobileMenu = document.querySelector('[data-mobile-menu]');
      this.lastScroll = 0;

      this.bindEvents();
      this.onScroll();
    },

    bindEvents: function () {
      var self = this;

      window.addEventListener('scroll', function () {
        self.onScroll();
      }, { passive: true });

      if (this.menuToggle) {
        this.menuToggle.addEventListener('click', function () {
          self.toggleMobileMenu();
        });
      }
    },

    onScroll: function () {
      var scrollY = window.scrollY;
      if (scrollY > 50) {
        this.header.classList.add('site-header--scrolled');
      } else {
        this.header.classList.remove('site-header--scrolled');
      }
      this.lastScroll = scrollY;
    },

    toggleMobileMenu: function () {
      this.menuToggle.classList.toggle('is-active');
      this.mobileMenu.classList.toggle('is-open');
      document.body.style.overflow = this.mobileMenu.classList.contains('is-open') ? 'hidden' : '';
    }
  };

  /* --- PRODUCT PAGE: GALLERY --- */

  var ProductGallery = {
    init: function () {
      this.gallery = document.querySelector('[data-product-gallery]');
      if (!this.gallery) return;

      this.slides = this.gallery.querySelectorAll('[data-gallery-slide]');
      this.thumbs = this.gallery.querySelectorAll('[data-gallery-thumb]');
      this.prevBtn = this.gallery.querySelector('[data-gallery-prev]');
      this.nextBtn = this.gallery.querySelector('[data-gallery-next]');
      this.currentIndex = 0;

      if (this.slides.length <= 1) return;
      this.bindEvents();
    },

    bindEvents: function () {
      var self = this;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.goTo(self.currentIndex - 1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.goTo(self.currentIndex + 1);
        });
      }

      this.thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = parseInt(this.getAttribute('data-gallery-thumb'), 10);
          self.goTo(index);
        });
      });
    },

    goTo: function (index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.slides.forEach(function (slide) {
        slide.classList.remove('is-active');
        slide.style.display = 'none';
      });
      this.slides[index].classList.add('is-active');
      this.slides[index].style.display = 'block';

      this.thumbs.forEach(function (thumb) {
        thumb.classList.remove('product-page__thumbnail--active');
      });
      if (this.thumbs[index]) {
        this.thumbs[index].classList.add('product-page__thumbnail--active');
      }

      this.currentIndex = index;
    }
  };

  /* --- PRODUCT PAGE: PILL SIZE SELECTOR --- */

  var PillSelector = {
    init: function () {
      this.pillContainers = document.querySelectorAll('[data-option-pills]');
      if (!this.pillContainers.length) return;

      this.productJSON = null;
      var jsonEl = document.querySelector('[data-product-json]');
      if (jsonEl) {
        try {
          this.productJSON = JSON.parse(jsonEl.textContent);
        } catch (e) {}
      }

      this.bindEvents();
    },

    bindEvents: function () {
      var self = this;

      this.pillContainers.forEach(function (container) {
        var pills = container.querySelectorAll('.product-page__pill');
        pills.forEach(function (pill) {
          pill.addEventListener('click', function () {
            // Deactivate siblings
            container.querySelectorAll('.product-page__pill').forEach(function (p) {
              p.classList.remove('product-page__pill--active');
            });
            this.classList.add('product-page__pill--active');

            self.updateVariant();
          });
        });
      });
    },

    updateVariant: function () {
      if (!this.productJSON) return;

      // Gather selected options
      var selectedOptions = [];
      this.pillContainers.forEach(function (container) {
        var activePill = container.querySelector('.product-page__pill--active');
        if (activePill) {
          selectedOptions.push(activePill.getAttribute('data-pill-value'));
        }
      });

      // Find matching variant
      var variant = null;
      this.productJSON.variants.forEach(function (v) {
        var match = true;
        selectedOptions.forEach(function (opt, i) {
          if (v.options[i] !== opt) match = false;
        });
        if (match) variant = v;
      });

      if (!variant) return;

      // Update hidden variant ID
      var variantInput = document.querySelector('[data-product-variant-id]');
      if (variantInput) variantInput.value = variant.id;

      // Update price display
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="product-page__price--sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="product-page__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      // Update ATC button
      var addBtn = document.querySelector('[data-add-to-cart]');
      var addBtnPrice = document.querySelector('[data-add-to-cart-price]');
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.innerHTML = 'Add to cart &mdash; <span data-add-to-cart-price>' + formatMoney(variant.price) + '</span>';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'SOLD OUT';
        }
      }

      // Update URL
      if (history.replaceState) {
        var url = window.location.pathname + '?variant=' + variant.id;
        history.replaceState({ variant: variant.id }, '', url);
      }
    }
  };

  /* --- PRODUCT PAGE: ACCORDIONS --- */

  var Accordions = {
    init: function () {
      var triggers = document.querySelectorAll('[data-accordion-trigger]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var content = this.parentElement.querySelector('[data-accordion-content]');
          var isOpen = this.classList.contains('is-open');

          // Toggle
          this.classList.toggle('is-open');
          content.classList.toggle('is-open');

          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            content.style.maxHeight = '0';
          }
        });
      });
    }
  };

  /* --- CART DRAWER --- */

  var CartDrawer = {
    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer) return;

      this.overlay = this.drawer.querySelector('[data-cart-overlay]');
      this.body = this.drawer.querySelector('[data-cart-body]');
      this.itemsContainer = this.drawer.querySelector('[data-cart-items]');
      this.emptyState = this.drawer.querySelector('[data-cart-empty]');
      this.footer = this.drawer.querySelector('[data-cart-footer]');
      this.subtotalEl = this.drawer.querySelector('[data-cart-subtotal]');
      this.countEl = document.querySelector('[data-cart-count]');

      this.bindEvents();
    },

    bindEvents: function () {
      var self = this;

      document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.close();
        });
      });

      if (this.overlay) {
        this.overlay.addEventListener('click', function () {
          self.close();
        });
      }
    },

    open: function () {
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },

    close: function () {
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    refresh: function () {
      var self = this;
      fetchJSON('/cart.js').then(function (cart) {
        self.render(cart);
      });
    },

    render: function (cart) {
      if (this.countEl) {
        this.countEl.textContent = cart.item_count;
      }

      if (cart.item_count === 0) {
        this.emptyState.style.display = '';
        this.itemsContainer.innerHTML = '';
        this.footer.style.display = 'none';
        return;
      }

      this.emptyState.style.display = 'none';
      this.footer.style.display = '';
      this.subtotalEl.textContent = formatMoney(cart.total_price);

      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="cart-drawer__item" data-cart-item data-line-key="' + item.key + '">';
        html += '  <div class="cart-drawer__item-image">';
        if (item.image) {
          html += '    <img src="' + item.image + '" alt="' + item.title + '" loading="lazy">';
        }
        html += '  </div>';
        html += '  <div class="cart-drawer__item-details">';
        html += '    <div>';
        html += '      <p class="cart-drawer__item-title">' + item.product_title + '</p>';
        if (item.variant_title) {
          html += '    <p class="cart-drawer__item-variant">' + item.variant_title + '</p>';
        }
        html += '    </div>';
        html += '    <div class="cart-drawer__item-bottom">';
        html += '      <div class="cart-drawer__item-quantity">';
        html += '        <button class="cart-drawer__qty-btn" data-qty-change="-1" data-line-key="' + item.key + '" aria-label="Decrease">\u2212</button>';
        html += '        <span class="cart-drawer__qty-value">' + item.quantity + '</span>';
        html += '        <button class="cart-drawer__qty-btn" data-qty-change="1" data-line-key="' + item.key + '" aria-label="Increase">+</button>';
        html += '      </div>';
        html += '      <span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>';
        html += '    </div>';
        html += '    <button class="cart-drawer__item-remove" data-remove-item data-line-key="' + item.key + '">Remove</button>';
        html += '  </div>';
        html += '</div>';
      });

      this.itemsContainer.innerHTML = html;
      this.bindItemEvents();
    },

    bindItemEvents: function () {
      var self = this;

      this.itemsContainer.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = this.getAttribute('data-line-key');
          var change = parseInt(this.getAttribute('data-qty-change'), 10);
          var qtyEl = this.parentNode.querySelector('.cart-drawer__qty-value');
          var newQty = parseInt(qtyEl.textContent, 10) + change;
          if (newQty < 1) newQty = 0;
          self.updateItem(key, newQty);
        });
      });

      this.itemsContainer.querySelectorAll('[data-remove-item]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = this.getAttribute('data-line-key');
          self.updateItem(key, 0);
        });
      });
    },

    updateItem: function (key, quantity) {
      var self = this;
      fetchJSON('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (cart) {
        self.render(cart);
      });
    },

    addItem: function (variantId, quantity) {
      var self = this;
      quantity = quantity || 1;
      return fetchJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      }).then(function () {
        self.open();
      });
    }
  };

  /* --- QUICK VIEW MODAL --- */

  var QuickView = {
    init: function () {
      this.modal = document.querySelector('[data-quick-view-modal]');
      if (!this.modal) return;

      this.content = this.modal.querySelector('[data-quick-view-content]');
      this.bindEvents();
    },

    bindEvents: function () {
      var self = this;

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-quick-view]');
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          var handle = trigger.getAttribute('data-product-handle');
          self.open(handle);
        }
      });

      this.modal.querySelectorAll('[data-quick-view-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.close();
        });
      });
    },

    open: function (handle) {
      var self = this;
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      this.content.innerHTML = '<div class="quick-view__loading"><div class="spinner"></div></div>';

      fetchJSON('/products/' + handle + '.js').then(function (product) {
        self.renderProduct(product);
      });
    },

    close: function () {
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    renderProduct: function (product) {
      var image = product.featured_image || '';
      var variant = product.variants[0];
      var hasVariants = product.variants.length > 1;

      var html = '';
      html += '<div class="quick-view__image-wrapper">';
      if (image) {
        html += '  <img class="quick-view__image" src="' + image + '" alt="' + product.title + '">';
      }
      html += '</div>';
      html += '<div class="quick-view__details">';
      html += '  <h2 class="quick-view__title">' + product.title + '</h2>';
      html += '  <p class="quick-view__price" data-qv-price>' + formatMoney(variant.price) + '</p>';

      if (hasVariants) {
        html += '  <select class="quick-view__variant-select" data-qv-variant>';
        product.variants.forEach(function (v) {
          var available = v.available ? '' : ' disabled';
          var label = v.available ? v.title : v.title + ' \u2014 Sold Out';
          html += '    <option value="' + v.id + '" data-price="' + v.price + '"' + available + '>' + label + '</option>';
        });
        html += '  </select>';
      }

      var disabled = variant.available ? '' : ' disabled';
      var buttonText = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      html += '  <button class="quick-view__add-to-cart" data-qv-add data-variant-id="' + variant.id + '"' + disabled + '>' + buttonText + '</button>';
      html += '</div>';

      this.content.innerHTML = html;
      this.bindProductEvents();
    },

    bindProductEvents: function () {
      var variantSelect = this.content.querySelector('[data-qv-variant]');
      var addBtn = this.content.querySelector('[data-qv-add]');
      var priceEl = this.content.querySelector('[data-qv-price]');

      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var selected = this.options[this.selectedIndex];
          var price = selected.getAttribute('data-price');
          var variantId = this.value;
          var available = !selected.disabled;

          addBtn.setAttribute('data-variant-id', variantId);
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
          priceEl.textContent = formatMoney(parseInt(price, 10));
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var variantId = parseInt(this.getAttribute('data-variant-id'), 10);
          this.disabled = true;
          this.textContent = 'ADDING...';

          CartDrawer.addItem(variantId, 1).then(function () {
            addBtn.textContent = 'ADDED';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = 'ADD TO CART';
              QuickView.close();
            }, 800);
          });
        });
      }
    }
  };

  /* --- PRODUCT PAGE: ADD TO CART AJAX --- */

  var ProductForm = {
    init: function () {
      var form = document.querySelector('.product-page form[action*="/cart/add"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = form.querySelector('[data-product-variant-id]');
        if (!variantId) return;

        var btn = form.querySelector('[data-add-to-cart]');
        if (btn) {
          btn.disabled = true;
          var originalText = btn.innerHTML;
          btn.textContent = 'ADDING...';

          CartDrawer.addItem(parseInt(variantId.value, 10), 1).then(function () {
            btn.textContent = 'ADDED';
            setTimeout(function () {
              btn.disabled = false;
              btn.innerHTML = originalText;
            }, 1200);
          });
        }
      });
    }
  };

  /* --- SEAMLESS PAGE TRANSITIONS (keeps audio playing) --- */

  var PageTransitions = {
    init: function () {
      this.mainContent = document.getElementById('main-content');
      if (!this.mainContent) return;

      this.isTransitioning = false;
      this.bindEvents();
    },

    bindEvents: function () {
      var self = this;

      // Intercept all internal link clicks
      document.addEventListener('click', function (e) {
        // Don't intercept if modifier keys held or transition in progress
        if (e.ctrlKey || e.metaKey || e.shiftKey || self.isTransitioning) return;

        var link = e.target.closest('a[href]');
        if (!link) return;

        var href = link.getAttribute('href');
        if (!href) return;

        // Skip external links, anchors, mailto, tel, javascript, etc.
        if (href.startsWith('http') && !href.includes(window.location.hostname)) return;
        if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

        // Skip links with target="_blank" or download
        if (link.getAttribute('target') === '_blank' || link.hasAttribute('download')) return;

        // Skip cart/checkout links (need full reload for Shopify checkout)
        if (href.includes('/checkout') || href.includes('/account/login') || href.includes('/account/register')) return;

        e.preventDefault();
        self.navigate(href);
      });

      // Handle browser back/forward
      window.addEventListener('popstate', function () {
        self.navigate(window.location.href, true);
      });
    },

    navigate: function (url, isPopState) {
      var self = this;
      this.isTransitioning = true;

      // Fade out current content
      this.mainContent.style.transition = 'opacity 0.2s ease';
      this.mainContent.style.opacity = '0';

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Swap main content
          var newMain = doc.getElementById('main-content');
          if (newMain) {
            self.mainContent.innerHTML = newMain.innerHTML;
          }

          // Update page title
          var newTitle = doc.querySelector('title');
          if (newTitle) document.title = newTitle.textContent;

          // Update body class
          var newBody = doc.querySelector('body');
          if (newBody) document.body.className = newBody.className;

          // Update cart count
          var newCartCount = doc.querySelector('[data-cart-count]');
          var currentCartCount = document.querySelector('[data-cart-count]');
          if (newCartCount && currentCartCount) {
            currentCartCount.textContent = newCartCount.textContent;
          }

          // Push to history (unless it's a popstate)
          if (!isPopState) {
            history.pushState({}, '', url);
          }

          // Scroll to top
          window.scrollTo(0, 0);

          // Re-initialize page-specific JS
          ProductGallery.init();
          PillSelector.init();
          Accordions.init();
          ProductForm.init();

          // Re-run any inline scripts in new content
          self.mainContent.querySelectorAll('script').forEach(function (oldScript) {
            var newScript = document.createElement('script');
            if (oldScript.src) {
              newScript.src = oldScript.src;
            } else {
              newScript.textContent = oldScript.textContent;
            }
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });

          // Fade in
          requestAnimationFrame(function () {
            self.mainContent.style.opacity = '1';
            self.isTransitioning = false;
          });

          // Trigger header scroll state recalculation
          Header.onScroll();
        })
        .catch(function () {
          // If fetch fails, do a normal navigation
          window.location.href = url;
        });
    }
  };

  /* --- INIT --- */

  function initPageModules() {
    Header.init();
    CartDrawer.init();
    QuickView.init();
    ProductGallery.init();
    PillSelector.init();
    Accordions.init();
    ProductForm.init();
    PageTransitions.init();
  }

  document.addEventListener('DOMContentLoaded', initPageModules);
})();
